import { z } from 'zod';

/**
 * Taric-Code (Modul engineering, ADR 0031): verwaltbare Zolltarifnummer mit
 * Beschreibung, auswählbar bei der Artikelanlage.
 */
export const createTaricCodeSchema = z.object({
  code: z.string().trim().min(1).max(40),
  description: z.string().trim().min(1).max(240),
  isActive: z.boolean().optional(),
});
export type CreateTaricCodeInput = z.infer<typeof createTaricCodeSchema>;

export const updateTaricCodeSchema = createTaricCodeSchema.partial();
export type UpdateTaricCodeInput = z.infer<typeof updateTaricCodeSchema>;

export const taricCodeResponseSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  code: z.string(),
  description: z.string(),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type TaricCodeResponse = z.infer<typeof taricCodeResponseSchema>;
